import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import menuState from './modules/main-menu/reducer';
import topBottomSectionState from './modules/topBottomSection/reducer';
import i18n from './modules/i18n/reducer';
import filters from './modules/filters/reducer';
import taxkeys from './modules/taxkeys/reducer';
import invoice from './modules/invoice/reducer';
import user from './modules/user/reducer';
import workers from './modules/workers/reducer';
import scrollPosition from './modules/scroll-positions/reducer';
import validationError from './modules/validation-errors/reducer';
import supplierLedgerTypes from './modules/supplier-ledger-types/reducer';
import bankId from './modules/bank-id/reducer';
import payment from './modules/payment/reducer';
import generalTerms from './modules/general-terms/reducer';
import currencies from './modules/currencies/reducer';
import timer from './modules/timer/reducer';
import bankInfo from './modules/bank-info/reducer';
import auth from './modules/auth/reducer';

export default combineReducers({
  router,
  i18n,
  menuState,
  topBottomSectionState,
  filters,
  taxkeys,
  invoice,
  user,
  workers,
  scrollPosition,
  validationError,
  supplierLedgerTypes,
  bankId,
  payment,
  generalTerms,
  currencies,
  timer,
  bankInfo,
  auth
});



/** WEBPACK FOOTER **
 ** ./src/redux/rootReducer.js
 **/